<template>
    <v-content class="pa-12">
        <v-layout style="background-color: #FAF5F2;">
            <v-flex>
                <v-layout mb-4>
                    <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
                        <span>แบบฟอร์ม</span>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex>
                        <v-layout pa-6 mt-3 style="background-color: #3E7662;">
                            <v-flex d-flex justify-start align-center style="font-size: 28px;color: white">
                                <div style="font-weight: bold" @click="setData()">หนังสือตอบรับ รายงานการไม่ปฏิบัติตามข้อกำหนด</div>
                            </v-flex>
                            <v-flex d-flex justify-end align-center style="font-weight: bold;font-size: 13px;color: white">
                                <span>RL 07_2560</span>
                            </v-flex>
                        </v-layout>

                    <!-- Start Form 1 -->
                        <v-card style="padding: 50px 70px 50px 70px">
                            <!-- Header -->
                            <v-layout>
                                <v-flex mr-4 shrink d-flex justify-start align-center>
                                    <img src="../../assets/LogoEN.png" width="124" alt="">
                                </v-flex>
                                <v-flex justify-start align-center>
                                    <!-- Text header -->
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span style="font-weight: bold;font-size: 18px;">Institutional Review Board, Royal Thai Army Medical Department</span>
                                        </v-flex>
                                    </v-layout>
                                    <!-- divider -->
                                    <v-layout mt-4>
                                        <v-flex>
                                            <v-divider style="background-color: #544A44;"></v-divider>
                                        </v-flex>
                                    </v-layout>
                                    <!-- Address -->
                                    <v-layout mt-2>
                                        <v-flex class="text-start">
                                            <span>317/5 Rajavithi Road, Rajathevee, Bangkok 10400, Thailand;Tel (662) 763-4297, (662) 763-4270</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span>Fax(662) 354-9011, E-mail:irbrta@yahoo.com, irbrta@amed.go.th</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span>Website: www.irbrta.pmk.ac.th, www.amed.go.th/rtamed/irbrta/</span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- No. IRBRTA -->
                            <v-layout style="margin-top: 80px;">
                                <v-flex class="text-end" xs1 pt-5 style="font-weight: bold;">
                                    <span>No IRBRTA</span>
                                </v-flex>
                                <v-flex xs2 ml-2 class="text-field-center">
                                    <v-text-field color="#3E7662" v-model="form.enIRBTABefore" hide-details />
                                </v-flex>
                                <span class="pt-5" style="font-weight: bold;">/</span>
                                <v-flex xs2 pr-2 class="text-field-center">
                                    <v-text-field color="#3E7662" v-model="form.enIRBTAAfter" hide-details />
                                </v-flex>
                            </v-layout>

                            <!-- (Month Date, Year e.g. May 21, 2012) -->
                            <v-layout>
                                <v-flex class="text-start" xs1 pt-5 style="font-weight: bold;"></v-flex>
                                <v-flex xs2 ml-2 class="text-field-center">
                                    <v-text-field color="#3E7662" v-model="form.enDate" hide-details />
                                </v-flex>
                                <v-flex ml-2 class="text-start" pt-5 style="font-weight: bold; color: #CC3D45;">
                                    <span>(Month Date, Year e.g. May 21, 2012)</span>
                                </v-flex>
                            </v-layout>

                            <!-- Dear -->
                            <v-layout style="margin-top: 80px">
                                <v-flex class="text-end" xs1 pt-5 style="font-weight: bold;">Dear</v-flex>
                                <v-flex xs5 ml-2>
                                    <v-text-field color="#3E7662" v-model="form.enReceiver" hide-details />
                                </v-flex>
                                <v-flex ml-2 class="text-start" pt-5 style="font-weight: bold; color: #CC3D45;">
                                    <span>(Principal investigator)</span>
                                </v-flex>
                            </v-layout>

                            <!-- Title of Project -->
                            <v-layout style="margin-top: 40px">
                                <v-flex class="text-end" xs1 mt-2 style="font-weight: bold;">Title of Project</v-flex>
                                <v-flex ml-2>
                                    <textfield-form
                                            :model="form.enTitle"
                                            style="font-weight: bold"
                                            @update-data="updateData('enTitle', $event)"
                                    ></textfield-form>
                                </v-flex>
                            </v-layout>

                            <!-- Code -->
                            <v-layout>
                                <v-flex class="text-end" xs1 mt-2 style="font-weight: bold;">Code</v-flex>
                                <v-flex xs4 ml-2>
                                    <textfield-form
                                            placeholder="EC"
                                            :model="form.enCode"
                                            style="font-weight: bold"
                                            @update-data="updateData('enCode', $event)"
                                    ></textfield-form>
                                </v-flex>
                            </v-layout>

                            <!-- Document Review : Progress report -->
                            <v-layout mt-12>
                                <v-flex class="text-start" xs1 mt-2 style="font-weight: bold;"></v-flex>
                                <v-flex xs4 ml-2 class="text-start">
                                    <span style="font-weight: bold;">Document received</span><span> : Protocol deviation</span>
                                </v-flex>
                            </v-layout>

                            <!-- Start Group Paragraph -->
                            <v-layout mt-12>
                                <v-flex class="text-start" xs1 mt-2 style="font-weight: bold;"></v-flex>
                                <v-flex xs10 class="text-start">
                                    <p style="text-indent: 6rem;" class=" text-field-margin text-field-center">
                                        <span class="mr-2">
                                            On the behalf of the Institutional Review Board, Royal
                                            Thai Army Medical Department, we would like to acknowledge
                                            the receipt of a protocol deviation/violation of the
                                            aforementioned project dated
                                        </span>
<!--                                        <v-text-field class="d-inline-block" hide-details color="3E7662" style="width: 10rem;" v-model="form.enProjectDate"/>-->
                                        <v-menu
                                                v-model="menuDateRL07_1"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        class="d-inline-block"
                                                        style="width: 10rem;"
                                                        v-model="dateChange2"
                                                        readonly
                                                        item-color="#3E7662"
                                                        color="#3E7662"
                                                        dense
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    @input="selectDate($event, 'menuDateRL07_1')"
                                                    locale="th"
                                                    type="date"
                                                    color="#3E7662"
                                                    header-color="#3E7662"
                                            ></v-date-picker>
                                        </v-menu>
                                    </p>
                                </v-flex>
                            </v-layout>

                            <!-- Start Group -->
                            <v-layout mt-6>
                                <v-flex class="text-start" xs1 mt-2 style="font-weight: bold;"></v-flex>
                                <v-flex xs10 class="text-start">

                                    <!-- Sincerely, -->
                                    <v-layout style="margin-top: 80px;">
                                        <v-flex mt-4 mr-2 shrink d-flex align-center class="text-start" style="font-weight: bold;font-size: 20px">
                                            <span>Sincerely,</span>
                                        </v-flex>
                                    </v-layout>

                                    <!--signature-->
                                    <v-layout style="margin-top: 60px">
                                        <v-flex xs5 d-flex align-center class="text-start">
                                            <v-text-field
                                                    v-model="form.enSignature"
                                                    color="#3E7662"
                                                    append-icon="edit"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout style="margin-bottom: 150px;">
                                        <v-flex xs5 style="font-weight: bold" class="text-start">
                                            <div>Colonel Suthee Panichkul, M.D.</div>
                                            <div>Chairperson,</div>
                                            <div>Institutional Review Board,</div>
                                            <div>Royal Thai Army Medical Department</div>
                                        </v-flex>
                                    </v-layout>

                                </v-flex>
                            </v-layout>
                            <!-- End Group -->
                            <v-layout>
                                <v-flex class="text-start">
                                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    <!-- End Form 1 -->

                    <!-- Start Form 2 -->
                        <v-card class="mt-12"  style="padding: 50px 70px 50px 70px">
                            <!-- Header -->
                            <v-layout>
                                <v-flex mr-4 shrink d-flex justify-start align-center>
                                    <img src="../../assets/LogoTh.png" width="124" alt="">
                                </v-flex>
                                <v-flex justify-start align-center>
                                    <!-- Text header -->
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span style="font-weight: bold;font-size: 18px;">คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก</span>
                                        </v-flex>
                                    </v-layout>
                                    <!-- divider -->
                                    <v-layout mt-4>
                                        <v-flex>
                                            <v-divider style="background-color: #544A44;"></v-divider>
                                        </v-flex>
                                    </v-layout>
                                    <!-- Address -->
                                    <v-layout mt-2>
                                        <v-flex class="text-start">
                                            <span>ชั้น 5 อาคารพระมงกุฎเกล้าเวชวิทยา วิทยาลัยแพทยศาสตร์พระมงกุฎเกล้า</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span>317/5ถนน ราชวิถีเขตราชเทวีกรุงเทพฯ 10400 โทรศัพท์, (662) 763-4297, (662) 763-4270โทรสาร (662) 354-9011</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span>www.irbrta.pmk.ac.th, www.amed.go.th/rtamed/irbrta/ E-mail; irbrta@yahoo.com, irbrta@amed.go.th</span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- No. IRBRTA and Code -->
                            <v-layout style="margin-top: 80px">
                                <v-flex xs4 d-flex align-center>
                                    <!-- No. IRBRTA -->
                                    <v-layout>
                                        <v-flex shrink pt-5 style="font-weight: bold;">
                                            <span>ที่่ IRBRTA</span>
                                        </v-flex>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.thIRBTABefore" hide-details />
                                        </v-flex>
                                        <span class="pt-5" style="font-weight: bold;">/</span>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.thIRBTAAfter" hide-details />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex xs4 d-flex align-center>
                                    <!-- Code -->
                                    <v-layout>
                                        <v-flex class="text-end" mr-4 pt-2 style="font-weight: bold;">
                                            <span>วัน/เดือน/ปี :</span>
                                        </v-flex>
                                        <v-flex>
                                            <v-menu
                                                    v-model="menuDatePage3"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menuDatePage3')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- เรื่อง -->
                            <v-layout mb-6 style="margin-top: 100px">
                                <v-flex class="text-end" xs1 style="font-weight: bold;">เรื่อง</v-flex>
                                <v-flex ml-2 class="text-start">
                                    <span style="font-weight: bold;">ตอบรับรายงานการเบี่ยงเบนหรือไม่ปฏิบัติตามโครงร่างการวิจัยฯ</span>
                                </v-flex>
                            </v-layout>

                            <!-- เรียน -->
                            <v-layout>
                                <v-flex class="text-end" xs1 mt-2 style="font-weight: bold;">เรียน</v-flex>
                                <v-flex xs5 ml-2>
                                    <textfield-form
                                            placeholder="ชื่อผู้วิจัยหลัก"
                                            :model="form.thReceiver"
                                            style="font-weight: bold"
                                            @update-data="updateData('thReceiver', $event)"
                                    ></textfield-form>
                                </v-flex>
                            </v-layout>

                            <!-- อ้างถึง -->
                            <v-layout>
                                <v-flex class="text-end" xs1 style="font-weight: bold;">อ้างถึง</v-flex>
                                <v-flex ml-2 class="text-start">
                                    <span style="color: #CC3D45">บันทึกข้อความที่ผู้วิจัยหลักส่ง (หนังสือหน่วย....กอง...โรงพยาบาล... ที่กห..../.. ลง..ว/ด/ป)</span>
                                </v-flex>
                            </v-layout>

                            <!-- Start Group Paragraph -->
                            <v-layout style="margin-top: 100px;margin-bottom: 80px;">
                                <v-flex class="text-start" xs1 mt-2 style="font-weight: bold;"></v-flex>
                                <v-flex xs10 class="text-start">
                                    <div style="text-indent: 6rem;" class="text-field-center text-field-margin change-placehoder">
                                        <span>ตามที่ท่านได้ส่งรายงานการเบี่ยงเบนหรือไม่ปฏิบัติตามโครงร่างการวิจัยฯเรื่อง</span>
                                        <v-text-field class="d-inline-block" placeholder="“ชื่อโครงการวิจัยภาษาไทย”" color="#3E7662" style="width: 20rem;" v-model="form.thResearchName"/>
                                        <span style="text-indent: 2rem;">&nbsp;
                                            <v-text-field class="d-inline-block" placeholder="[ชื่อโครงการวิจัยภาษาอังกฤษ]" color="#3E7662" style="width: 20rem;" v-model="form.enResearchName"/>
                                        </span>
                                        <span> คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก ได้ทบทวน และขอตอบรับรายงานดังกล่าวเมื่อ</span>
                                        <span class="ml-2 text-field-center">
                                            <v-menu
                                                    v-model="menu_date1"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            class="d-inline-block"
                                                            style="width: 10rem"
                                                            placeholder="ว/ด/ป"
                                                            v-model="dateChange1"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date1')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </span>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <!-- End Group Paragraph -->


                            <!-- Start Group -->
                            <v-layout mt-6>
                                <v-flex class="text-start" xs1 mt-2 style="font-weight: bold;"></v-flex>
                                <v-flex xs10 class="text-start">

                                    <!-- ทั้งนี้คณะอนุกรรมการฯ -->
                                    <v-layout mt-12>
                                        <v-flex class="text-start">
                                            <div style="text-indent: 10rem;" class="text-field-margin change-placehoder">
                                                <span class="mr-2">ทั้งนี้คณะอนุกรรมการฯ ขอทราบ </span>
                                                <v-text-field class="d-inline-block" color="#3E7662" hide-details style="width: 18rem;" v-model="form.thReviewerAdvice1"/>
                                                <span class="mr-2">(หรือขอแนะนําให้ท่าน) หรือ</span>
                                                <v-text-field class="d-inline-block" color="#3E7662" hide-details style="width: 20rem;" v-model="form.thReviewerAdvice2"/>
                                            </div>
                                        </v-flex>
                                    </v-layout>

                                    <!-- จึงเรียนมาเพื่อทราบ -->
                                    <v-layout style="margin-top: 100px;">
                                        <v-flex mt-4 mr-2 shrink d-flex align-center class="text-start" style="font-weight: bold;font-size: 20px">
                                            <span>จึงเรียนมาเพื่อทราบ</span>
                                        </v-flex>
                                    </v-layout>

                                    <!--signature-->

                                    <v-layout mt-6>
                                        <v-spacer></v-spacer>
                                        <v-flex class="text-center" xs5 style="font-weight: bold;font-size: 20px;">
                                            <div>ขอแสดงความนับถือ</div>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout mt-6>
                                        <v-spacer></v-spacer>
                                        <v-flex shrink pt-5 class="text-end">
                                            <span style="font-weight: bold;">พันเอก</span>
                                        </v-flex>
                                        <v-flex xs5 pl-2 d-flex align-center class="text-end text-field-center" style="font-weight: bold">
                                            <v-text-field
                                                    v-model="form.enSignature"
                                                    color="#3E7662"
                                                    append-icon="edit"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-spacer></v-spacer>
                                        <v-flex class="text-center" xs5 style="font-weight: bold">
                                            <div>(สุธีพานิชกุล)</div>
                                            <div>ประธานคณะอนุกรรมการพิจารณาโครงการวิจัย</div>
                                            <div>กรมแพทย์ทหารบก</div>
                                        </v-flex>
                                    </v-layout>

                                </v-flex>
                            </v-layout>
                            <!-- End Group -->
                            <v-layout mt-12>
                                <v-flex class="text-start">
                                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    <!-- End Form 2 -->

                        <!-- Button Save -->
                        <v-layout mt-8>
                            <v-flex mb-12 style="text-align: right;">
                                <v-layout>
                                    <v-flex>
                                        <v-btn style="color: #3E7662" class="mx-4" depressed  color="#ffffff" @click.native="$router.go(-1)">ย้อนกลับ</v-btn>
                                        <v-btn depressed  dark color="#3E7662" @click="save">
<!--                                            <v-icon class="mr-3">add</v-icon>-->
                                            <span>บันทึกข้อมูล</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <loading
                        color="#527281"
                        :active.sync="isLoading"
                        :can-cancel="false"
                        :is-full-pageAndLine="fullpageAndLine"
                ></loading>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    import TextfieldForm from "../../components/input/TextfieldForm";
    import DateInputForm from "../../components/input/DateInputForm";
    import TextareaForm from "../../components/input/TextareaForm";
    import Swal from 'sweetalert2';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
    import { mapState } from "vuex";

    export default {
        name: "FormRF06",
        components: {
            TextfieldForm,
            DateInputForm,
            TextareaForm,
            Loading,
            TextfieldFormAppend,
        },
        data: () => ({
            isLoading: false,
            fullpageAndLine: true,
            menu_date1: false,
            menuDatePage3: '',
            menuDateRL07_1: '',
            disabled: false,
            form: {
                researchID: '',
                enIRBTABefore: '',
                enIRBTAAfter: '',
                enDate: '',
                enReceiver: '',
                enTitle: '',
                enCode: '',
                enProjectDate: '',
                enSignature: '',
                thIRBTABefore: '',
                thIRBTAAfter: '',
                thDate: '',
                thReceiver: '',
                thResearchName: '',
                enResearchName: '',
                thAcceptDate: '',
                thReviewerAdvice1: '',
                thReviewerAdvice2: '',
                thSignature: '',
            },
            dateChange1: '',
            dateChange2: '',
            dateChange: '',
        }),
        computed: {
            ...mapState({
                user: state => state.Auth.user
            })
        },
        created() {
            // Check Permission Access
        //    if (this.user.currentRole !== 4) {
         //       this.$router.go(-1);
        //    }
            this.getRL07();
        },
        methods:{
            updateData(name, val) {
                this.form[name] = val;
            },
            save() {
                Swal.fire({
                    title: 'คุณต้องการบันทึกหรือไม่?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3E7662',
                    cancelButtonColor: 'rgb(189, 189, 189)',
                    confirmButtonText: 'ใช่ บันทึก',
                }).then((result) => {
                    if (result.value) {
                        this.isLoading = true;
                        this.form['researchID'] = this.$route.query.id;
                        // console.log(this.form);
                        this.$store.dispatch("FormRL/saveRL07", this.form).then(res => {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'บันทึกสำเร็จ',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            this.isLoading = false;
                        }).catch(e => {
                            this.isLoading = false;
                            if (e.response.data.errors) {
                                for (var k in e.response.data.errors) {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาด",
                                    text: e.response.data.errors[k][0],
                                    icon: "warning",
                                    confirmButtonColor: "#3E7662",
                                }).then(() => {
                                    this.$vuetify.goTo(`#${k}`);
                                });
                                }
                            }
                            // Swal.fire({
                            //     title: 'Save failed!',
                            //     text: 'บันทึกไม่สำเร็จ',
                            //     icon: 'warning',
                            // })
                            // this.isLoading = false;
                        })
                    }
                });
            },
            getRL07() {
                this.isLoading = true;
                this.$store.dispatch("FormRL/getRL07", this.$route.query.id).then(res => {
                    // console.log('getRL07 : ' ,res);
                    this.form.researchID = res.researchID;
                    this.form.enIRBTABefore = res.enIRBTABefore;
                    this.form.enIRBTAAfter = res.enIRBTAAfter;
                    this.form.enDate = res.enDate;
                    this.form.enReceiver = res.enReceiver;
                    this.form.enTitle = res.enTitle;
                    this.form.enCode = res.enCode;
                    this.selectDate(res.enProjectDate,'menuDateRL07_1');
                    this.form.enProjectDate = res.enProjectDate;
                    this.form.enSignature = res.enSignature;
                    this.form.thIRBTABefore = res.thIRBTABefore;
                    this.form.thIRBTAAfter = res.thIRBTAAfter;
                    this.selectDate(res.thDate,'menuDatePage3');
                    this.form.thDate = res.thDate;
                    this.form.thReceiver = res.thReceiver;
                    this.form.thResearchName = res.thResearchName;
                    this.form.enResearchName = res.enResearchName;
                    this.selectDate(res.thAcceptDate,'menu_date1');
                    this.form.thAcceptDate = res.thAcceptDate;
                    this.form.thReviewerAdvice1 = res.thReviewerAdvice1;
                    this.form.thReviewerAdvice2 = res.thReviewerAdvice2;
                    this.form.thSignature = res.thSignature;
                    this.isLoading = false;
                }).catch(e => {
                    this.isLoading = false;
                })
            },
            selectDate(val,name) {
                if (name === 'menu_date1') {
                    // console.log(val)
                    this.menu_date1 = false
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange1 = changeDate;
                    this.form.thAcceptDate  = val;
                }
                if (name === 'menuDatePage3') {
                    this.menuDatePage3 = false
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange = changeDate;
                    this.form.thDate= val;
                }
                if (name === 'menuDateRL07_1') {
                    this.menuDateRL07_1 = false
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange2 = changeDate;
                    this.form.enProjectDate= val;
                }

            },
            // Change Date
            changeDate(val) {
                //change date start
                let sub_year = val.substring(0,4);
                let sub_month = val.substring(5,7);
                let sub_day = val.substring(8,10);

                sub_year = parseInt(sub_year)+543;

                let changeDate = sub_day + '/' + sub_month + '/' + sub_year;
                return changeDate;
            },
            setData() {
                this.form.researchID='Test';
                this.form.enIRBTABefore='Test';
                this.form.enIRBTAAfter= 'Test';
                this.form.enDate='2020-02-12';
                this.form.enReceiver= 'Test';
                this.form.enTitle= 'Test';
                this.form.enCode= 'Test';
                this.form.enProjectDate= '2020-02-12';
                this.form.enSignature= 'Test';
                this.form.thIRBTABefore= 'Test';
                this.form.thIRBTAAfter= 'Test';
                this.form.thDate= '2020-02-12';
                this.form.thReceiver= 'Test';
                this.form.thResearchName= 'Test';
                this.form.enResearchName= 'Test';
                this.form.thAcceptDate= '2020-02-12';
                this.form.thReviewerAdvice1= 'Test';
                this.form.thReviewerAdvice2= 'Test';
                this.form.thSignature= 'Test';
            },
        },
    }
</script>

<style lang="scss">
    /*** Table Styles **/
    .table-style {
        .table-fill {
            background: white;
            border-radius:3px;
            border-collapse: collapse;
            margin: auto;
            padding:5px;
            width: 100%;
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
            animation: float 5s infinite;
            border-bottom: 5px solid #544A44;
        }

        th {
            color:#D5DDE5;;
            background:#3E7662;
            border-top:5px solid #544A44;
            border-right: 1px solid #544A44;
            font-weight: 700;
            padding:15px;
            vertical-align:middle;
        }

        /*th:first-child {*/
        /*    border-top-left-radius:3px;*/
        /*}*/

        th:last-child {
            border-top-right-radius:3px;
            border-right:none;
        }

        tr {
            border-top: 1px solid #544A44;
            border-bottom-: 1px solid #544A44;
            color:#ffffff;
        }

        /*tr:hover td {*/
        /*    background:#4E5066;*/
        /*    color:#FFFFFF;*/
        /*    border-top: 1px solid #22262e;*/
        /*}*/

        tr:first-child {
            border-top:none;
        }

        tr:last-child {
            /*border-bottom:5px solid #544A44;*/
        }

        /*tr:nth-child(odd) td {*/
        /*    background:#EBEBEB;*/
        /*}*/

        /*tr:nth-child(odd):hover td {*/
        /*    background:#4E5066;*/
        /*}*/

        tr:last-child td:first-child {
            border-bottom-left-radius:3px;
        }

        tr:last-child td:last-child {
            border-bottom-right-radius:3px;
        }

        td {
            background:#FFFFFF;
            padding:10px 30px 10px 30px;
            text-align:left;
            vertical-align:middle;
            font-weight:700;
            color: black;
            border-right: 1px solid #544A44;
        }

        td:last-child {
            border-right: 0px;
        }

        th.text-left {
            text-align: left;
        }

        th.text-center {
            text-align: center;
        }

        th.text-right {
            text-align: right;
        }

        td.text-left {
            text-align: left;
        }

        td.text-center {
            text-align: center;
        }

        td.text-right {
            text-align: right;
        }
    }
    .text-field-color {
         .theme--light.v-input, .theme--light.v-input input, .theme--light.v-input textarea {
             color: #CC3D45;
         }
    }
    .text-field-margin {
        .v-text-field {
            padding-top: 0;
            margin: 0;
        }
    }


</style>
